import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { AppExceptionModel } from '../../models/app-exception.model';

import { Exam } from '../../models/exam.school.model';
import * as examActions from '../actions/exam.school.actions';

export interface ExamState extends EntityState<Exam> {
  loading: boolean;
  loaded: boolean;
  inProgress: boolean;
  examStatsLoading: boolean;
  error: AppExceptionModel | undefined;
}

export const examAdapter: EntityAdapter<Exam> = createEntityAdapter<Exam>();

export const initialState: ExamState = examAdapter.getInitialState({
  loading: false,
  loaded: false,
  inProgress: false,
  examStatsLoading: false,
  error: undefined,
});

export const schoolExamReducer = createReducer(
  initialState,
  on(examActions.getExams, (state, {}) => ({
    ...state,
    loading: true,
    loaded: false,
    error: undefined,
  })),
  on(examActions.getExam, (state, {}) => ({
    ...state,
    error: undefined,
  })),
  on(examActions.addExamToStore, (state, { exam }) =>
    examAdapter.upsertOne(exam, {
      ...state,
      error: undefined,
      loading: false,
      loaded: true,
    }),
  ),
  on(examActions.addExamsToStore, (state, { exams }) => {
    return examAdapter.upsertMany(exams, {
      ...state,
      loading: false,
      loaded: true,
      inProgress: false,
      error: undefined,
    });
  }),
  on(examActions.getExamsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    loaded: true,
    error: error,
  })),
  on(examActions.getExamFailure, (state, { error }) => ({
    ...state,
    loading: false,
    loaded: true,
    error: error,
  })),
  on(examActions.create, (state, { exam }) => ({
    ...state,
    error: undefined,
    inProgress: true,
  })),
  on(examActions.createSuccess, (state, { exam }) =>
    examAdapter.upsertOne(exam, {
      ...state,
      error: undefined,
      inProgress: false,
    }),
  ),
  on(examActions.createFailure, (state, { error }) => ({
    ...state,
    error: error,
    inProgress: false,
  })),
  on(examActions.update, (state, { exam }) => ({
    ...state,
    error: undefined,
    inProgress: true,
  })),
  on(examActions.updateSuccess, (state, { exam }) =>
    examAdapter.upsertOne(exam, {
      ...state,
      error: undefined,
      inProgress: false,
    }),
  ),
  on(examActions.updateFailure, (state, { error }) => ({
    ...state,
    error: error,
    inProgress: false,
  })),

  on(examActions.deleteAction, (state, { id }) => ({
    ...state,
    error: undefined,
    inProgress: true,
  })),
  on(examActions.deleteSuccess, (state, { id }) =>
    examAdapter.removeOne(id, {
      ...state,
      error: undefined,
      inProgress: false,
    }),
  ),
  on(examActions.deleteFailure, (state, { error }) => ({
    ...state,
    error: error,
    inProgress: false,
  })),

  on(examActions.clearFromStore, (state, { ids }) =>
    examAdapter.removeMany(ids, {
      ...state,
      error: undefined,
      inProgress: false,
    }),
  ),
  on(examActions.clear, (state) => initialState),
);
